module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_fairs-95d208a778ea0e27f07fa67201030fbc.jpg";